import {
  Container,
  ContinueLogin,
  DivComponentEmail,
  ExtrasContainer,
  LoadingContainer,
  LoginBox,
  Logo,
  RadioContainer,
  UserTypeContainer,
} from "./styles";
import capivara from "../../../../assets/images/capivara.png";
import { useEffect, useState } from "react";
import { useAuthContext } from "../../../../contexts/auth-contex";
import { useNavigate } from "react-router-dom";
import { Input } from "../../../../components/inputs";
import { Page } from "../../../../components/page-base";
import permissionsStore from "../../../../store/permissions";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import theme from "@/styles/theme";
import GoogleIcon from "@mui/icons-material/Google";
import {
  LoginSocialGoogle,
  //LoginSocialInstagram,
  IResolveParams,
  // @ts-expect-error
} from "reactjs-social-login";
import { LoginService } from "../../services";
import { toast } from "react-toastify";
import { TUser, TUserType } from "@/modules/users/models";
import { Radio } from "@mui/material";
export const Login: React.FC = () => {
  const { login, user, proceedLogin } = useAuthContext();
  const { role, storageUser } = permissionsStore();

  const navigate = useNavigate();

  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [emailConfirm, setEmailConf] = useState<boolean>(true);
  const [verifyEmail, setVerifyEmail] = useState<boolean>(false);
  const [isDisabledButtonEmail, setIsDisabledButtonEmail] = useState(true);
  const [displayRadio, setdisplayRadio] = useState<boolean>(false);
  const [userType, setUserType] = useState<TUserType>("PERSON");
  const [document, setDocument] = useState<string>("");
  const [isDocValid, setIsDocValid] = useState<boolean>(false);
  const [disabledButtonSocial, setdisabledButtonSocial] =
    useState<boolean>(false);

  const [countdown, setCountdown] = useState(10);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    if (!executeRecaptcha) {
      // Caso a função ainda não esteja disponível
      console.error("Erro ao gerar token captcha;");
      return false;
    }

    const token = await executeRecaptcha("login");

    if (!emailConfirm) {
      setVerifyEmail(true);
    }

    const loginResult = await login(email, password, token);

    if (loginResult === "Cheque sua caixa de email para confirmar a conta!") {
      setEmailConf(false);
    }

    setLoading(false);
  };

  useEffect(() => {
    setIsDisabledButtonEmail(true);
    setCountdown(10);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsDisabledButtonEmail(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [emailConfirm]);

  useEffect(() => {
    if (role && storageUser && user) {
      navigate("/home");
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 250);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (loading) {
    return <LoadingContainer>Carregando...</LoadingContainer>;
  }
  const handleCreateAccountClick = () => {
    navigate("/signup");
  };

  const handleEmailChange = (value: string) => {
    setEmail(value.toLowerCase());
  };

  const proceedSocialLogin = async (
    email: string,
    accessToken: string,
    provider: string,
    setup: "login" | "signup",
    name: string
  ): Promise<void> => {
    try {
      const { success, message, metadata } = await LoginService.accountSetup(
        email,
        accessToken,
        provider,
        setup
      );

      if (!success) {
        toast.error(message);
        return;
      }
      if (setup === "login") {
        toast.success(message);
        proceedLogin(metadata as TUser);
      } else {
        setName(name);
        setEmail(email);
        setdisplayRadio(true);
        /*navigate(
          `/login-social?email=${encodeURIComponent(
            email
          )}&name=${encodeURIComponent(name)}`
        );*/
      }
    } catch (error) {
      console.error("Erro durante o setup da conta:", error);
      toast.error("Ocorreu um erro no processo de autenticação.");
    }
  };

  const handleSocialLogin = async ({ provider, data }: IResolveParams) => {
    const { email, access_token: accessToken, name } = data;
    if (!email || !accessToken || !name) {
      toast.error("Dados insuficientes para o processo de autenticação.");
      setLoading(false);
      return;
    }

    try {
      const res = await LoginService.emailExists(email);
      if (!res.success) {
        toast.error(res.message);
        return;
      }

      const setup = res.exists ? "login" : "signup";
      await proceedSocialLogin(email, accessToken, provider, setup, name);
    } catch (error) {
      console.error("Erro durante o setup da conta:", error);
      toast.error("Ocorreu um erro no processo de autenticação.");
    } finally {
      setLoading(false);
    }
  };
  const handleUserType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserType((event.target as HTMLInputElement).value as TUserType);
  };
  const cancelSocialLogin = () => {
    setName("");
    setEmail("");
    setUserType("PERSON");
    setdisplayRadio(false);
  };
  const handleCreateSocialAccount = async () => {
    setdisabledButtonSocial(true);
    if (!email || !name) {
      toast.error("Dados insuficientes para o processo de autenticação.");
      setdisabledButtonSocial(false);
      setLoading(false);
      return;
    }
    try {
      if (!executeRecaptcha) {
        // Caso a função ainda não esteja disponível
        console.error("Erro ao gerar token captcha;");
        return false;
      }

      const token = await executeRecaptcha("login");

      const { success, message, metadata } = await LoginService.signUpSocial(
        name,
        email,
        userType,
        token,
        document
      );
      if (!success) {
        toast.error(message);
        setdisabledButtonSocial(false);
        return;
      }
      toast.success(message);
      localStorage.setItem("puxa-capivara-free-credit", "true");
      proceedLogin(metadata as TUser);
    } catch (error) {
      setdisabledButtonSocial(false);
      console.error("Erro durante o setup da conta:", error);
      toast.error("Ocorreu um erro no processo de criação de conta.");
    }
  };

  return (
    <Container>
      <LoginBox className="laptop:max-w-[500px]">
        <Logo>
          <img src={capivara} alt="Logo" />
        </Logo>
        {emailConfirm && (
          <div>
            {!displayRadio && (
              <form
                onSubmit={handleSubmit}
                style={{
                  rowGap: "1vh",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Input.Label
                  label="Email"
                  placeholder=""
                  setValue={handleEmailChange}
                  value={email}
                  type="email"
                  required
                />
                <Input.Password
                  label="Senha"
                  placeholder=""
                  setValue={setPassword}
                  value={password}
                  required
                />
                <Page.Button type="submit" label="Acessar" />
              </form>
            )}
            <ExtrasContainer>
              {!displayRadio && (
                <>
                  <a href="/login/request-new-password" className="anchor ">
                    Esqueceu a senha?
                  </a>

                  <div className="flex items-center w-[90%] mx-auto my-3">
                    <hr className="flex-1 border-gray-400" />
                    <span className="mx-2 !text-[10px] uppercase text-gray-600">
                      OU
                    </span>
                    <hr className="flex-1 border-gray-400" />
                  </div>
                </>
              )}
              <div className="btns-account-container">
                {!displayRadio && (
                  <>
                    <LoginSocialGoogle
                      client_id={import.meta.env.VITE_APP_GG_APP_ID || ""}
                      onResolve={handleSocialLogin}
                      onReject={(err: unknown) => {
                        console.log(err);
                        setLoading(false);
                      }}
                      scope="profile email"
                      onLoginStart={() => {
                        setLoading(true);
                      }}
                    >
                      <Page.Button
                        startIcon={<GoogleIcon sx={{ fontSize: 21 }} />}
                        label="Acessar ou criar nova conta com o Google"
                        onClick={() => {}}
                        bgColor="#4285F4"
                        color="white"
                        hoverBgcolor="#6EA8FF"
                      />
                    </LoginSocialGoogle>
                    <Page.Button
                      label="Criar nova conta com email"
                      onClick={handleCreateAccountClick}
                      bgColor={theme.colors.palete.gold}
                      color="black"
                    />
                  </>
                )}
                {displayRadio && (
                  <>
                    <ContinueLogin>
                      <span className="welcome">Bem vindo(a) {name}</span>
                      <RadioContainer>
                        <span>Eu sou:</span>
                        <div
                          className="flex items-center justify-around w-full"
                          onChange={handleUserType}
                        >
                          <label>
                            <Radio
                              name="user-type"
                              value="PERSON"
                              checked={userType === "PERSON"}
                            />
                            Pessoa Física
                          </label>
                          <label>
                            <Radio
                              name="user-type"
                              value="COMPANY"
                              checked={userType === "COMPANY"}
                            />
                            Pessoa Jurídica
                          </label>
                        </div>
                      </RadioContainer>
                      <UserTypeContainer>
                        <Input.Masked
                          label={userType === "COMPANY" ? "CNPJ" : "CPF"}
                          type={userType === "COMPANY" ? "CNPJ" : "CPF"}
                          setValue={setDocument}
                          setIsValid={setIsDocValid}
                          isValid={isDocValid}
                          required
                        />
                      </UserTypeContainer>
                    </ContinueLogin>

                    <div className="btns-account-container">
                      <Page.Button
                        label="Finalizar"
                        onClick={handleCreateSocialAccount}
                        bgColor={theme.colors.palete.green}
                        hoverBgcolor={theme.colors.palete.greenHover}
                        color="white"
                        disabled={!isDocValid || disabledButtonSocial}
                      />
                      <Page.Button
                        label="Cancelar"
                        onClick={cancelSocialLogin}
                        bgColor={theme.colors.palete.red}
                        hoverBgcolor={theme.colors.palete.redHover}
                        color="white"
                      />
                    </div>
                  </>
                )}
              </div>
            </ExtrasContainer>
          </div>
        )}
        {!emailConfirm && (
          <DivComponentEmail>
            <p>
              Para continuar, confirme seu endereço de email. <br />
              Basta ir até a sua caixa de entrada e clicar no link que te
              enviamos.
            </p>

            <Page.Button
              type="button"
              bgColor={isDisabledButtonEmail ? "zinc" : "green"}
              disabled={isDisabledButtonEmail}
              hoverBgcolor="#008035"
              label={
                isDisabledButtonEmail
                  ? `Aguarde ${countdown}s`
                  : "JÁ CONFIRMEI MEU EMAIL"
              }
              onClick={() =>
                handleSubmit({
                  preventDefault: () => {},
                } as React.FormEvent<HTMLFormElement>)
              }
            />
            {verifyEmail && (
              <div>
                <WarningAmberOutlinedIcon />
                <span>Email não verificado!</span>
              </div>
            )}
          </DivComponentEmail>
        )}
      </LoginBox>
      <div className="links-container">
        <a className="link-item" href="/privacy-policy">
          Política de Privacidade
        </a>
      </div>
    </Container>
  );
};
